module.exports = __webpack_public_path__ + "static/media/employee_inactive_icon.460bc050.svg";